module.exports = __webpack_public_path__ + "static/media/logo-left-grey.af1fcff8.png";